export default __webpack_public_path__ + "static/media/sketch-league-tn.81c9a5ef.png";